<template>
  <div class="page">
    <div class="m-nav">
      <div class="m-title">
        <span class="m-des">身份证照片</span>
      </div>
      <p class="m-p">上传与注册信息一致的身份证照片</p>
      <div class="m-up-box">
        <div class="m-file-box">
          <van-uploader class="m-top-margin" :multiple="true" :max-count="1" :before-read="beforeRead"
                        :after-read="(e)=> afterRead(e,1)" accept="image/*">
            <img :src="fileHome ? fileHome : require('@/assets/img/home/Groups788.png')" alt="">
          </van-uploader>
        </div>
        <div class="m-file-box">
          <van-uploader class="m-top-margin" :multiple="true" :max-count="1" :before-read="beforeRead"
                        :after-read="(e)=> afterRead(e,2)" accept="image/*">
            <img :src="fileBack ? fileBack : require('@/assets/img/home/Groups978.png')" alt="">
          </van-uploader>
        </div>
      </div>
      <!--示例-->
      <div class="m-prompt">
        <p>上传示例</p>
        <div class="m-prompt-box">
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/sda.png" alt="">
            <van-icon class="m-icon" name="checked" />
            <span>标准</span>
          </div>
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/xczx.png" alt="">
            <van-icon class="m-icon-w" name="warning" />
            <span>边框缺失</span>
          </div>
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/sdaszx.png" alt="">
            <van-icon class="m-icon-w" name="warning" />
            <span>对焦模糊</span>
          </div>
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/zsd.png" alt="">
            <van-icon class="m-icon-w" name="warning" />
            <span>反光强烈</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="authUpImage==1" class="m-nav">
      <div class="m-title">
        <span class="m-des">证件照片</span>
      </div>
      <div class="m-card-box">
        <div class="m-card-item">
          <img src="@/assets/img/home/wxtu_20240103161550_43.png" alt="">
          <p class="m-left-p">证件照示例</p>
          <p>大小4M以下</p>
        </div>
        <div class="m-card-item">
          <van-uploader class="m-top-margin" :multiple="true" :max-count="1" :before-read="beforeRead"
                        :after-read="(e)=> afterRead(e,3)" accept="image/*">
            <img class="m-up-card" :src="fileCard ? fileCard : require('@/assets/img/home/Group21056.png')" alt="">
          </van-uploader>
          <p class="m-right-p">点击上传证件照片</p>
        </div>
      </div>
    </div>
    <!--<div class="m-nav">-->
      <!--<div class="m-title">-->
        <!--<span class="m-des">注册信息</span>-->
      <!--</div>-->
      <!--<div class="m-item" style="margin-top: 20px"><span>真实姓名</span><p>{{people.realName}}</p></div>-->
      <!--<div class="m-item"><span>证件号码</span><p>{{people.idCardNum}}</p></div>-->
    <!--</div>-->
    <div class="des-bg">
      <p>温馨提示: </p>
      <p>1、身份证信息必须与注册信息一致，如不一致请在个人信息中修改姓名或身份证号</p>
      <p v-if="authUpImage==1">2、上传考生本人清晰近期正面免冠彩色证件照。成像区上下要求头上部空1/10，头部占7/10，肩部占1/5，左右各空1/10。采集的图象大小最小为192×144（高×宽），成像区大小为48mm×33mm（高×宽）</p>
    </div>
    <van-button block class="x-btn-log m-btn" native-type="button" @click="submit()">开始认证</van-button>
  </div>
</template>

<script>
  import { Dialog } from 'vant';
  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
    },
    data () {
      return {
        fileHome: '',
        fileBack: '',
        people:{},
        fileCard:'',
        authUpImage:'',
      }
    },
    created () {
      this.getInfo()
    },
    methods: {
      beforeRead(e){
        if(e.length>1){
          this.utils.toastError('只能选择一张图片上传！')
          return false
        }
        if(e.size>4194304){
          this.utils.toastError('文件大小不能超过4MB！')
          return false
        }
        return true
      },
      afterRead (e,keys) {
        if(keys==1){
          this.fileHome = e.content
        } else if(keys==2){
          this.fileBack = e.content
        } else {
          this.fileCard = e.content
        }
      },
      submit(){
        if(!this.fileHome){
          this.utils.toastNone('请上传身份证正面照！')
          return
        }
        if(!this.fileBack){
          this.utils.toastNone('请上传身份证反面照!')
          return
        }
        if(this.authUpImage==1&&!this.fileCard){
          this.utils.toastNone('请上传证件照!')
          return
        }
        this.postHomeFile()
      },
      //上传正面照
      postHomeFile(){
//        let msg = new FormData()
//        msg.append('imgBase64', this.fileHome);
        this.http.postRequest({
//          headers: {'Content-Type': 'multipart/form-data'},
          url: 'app/faceAuth/readIdcardFront',
          msg: {imgBase64:this.fileHome},
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            Dialog.alert({
              title: '身份证正面照认证失败',
              message: res.msg||res.code,
              confirmButtonColor: '#2B6CF9',
            }).then(() => {})
          }
          if(res.code==200){
            this.postBackFile()
          }
        },true)
      },
      //上传反面照
      postBackFile(){
//        let msg = new FormData()
//        msg.append('imgBase64', this.fileBack);
        this.http.postRequest({
//          headers: {'Content-Type': 'multipart/form-data'},
          url: 'app/faceAuth/readIdcardBack',
          msg: {imgBase64:this.fileBack},
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            Dialog.alert({
              title:'身份证反面照认证失败',
              message: res.msg||res.code,
              confirmButtonColor: '#2B6CF9',
            }).then(() => {})
          }
          if(res.code==200){
            if(this.authUpImage==1){
              this.postCardFile()
            }else {
              this.utils.toastSuccess('认证成功!')
              this.$router.replace('/realSuccess')
            }

          }
        },true)
      },
      //上传证件照
      postCardFile(){
        this.http.postRequest({
          url: 'app/faceAuth/cardPhotoFace',
          msg: {imgBase64:this.fileCard},
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            Dialog.alert({
              title: '证件照认证失败',
              message: res.msg||res.code,
              confirmButtonColor: '#2B6CF9',
            }).then(() => {})
          }
          if(res.code==200){
            this.utils.toastSuccess('认证成功!')
            this.$router.replace('/realSuccess')
          }
        },true)
      },
      //    获取个人信息
      getInfo () {
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.people = res.data
          }
        })
      },
    },
    mounted () {
      if(this.$route.query.authUpImage){
        this.authUpImage = 1
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page {
    background: #F4F6F9;
    padding: 0 12px 50px 12px;
    .m-nav {
      margin-top: 15px;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      .m-title:before{
        display: inline-block;
        content: '';
        width: 4px;
        height: 18px;
        background: #457DF9;
        border-radius: 2px;
        margin-right: 4px;
      }
      .m-title {
        display: flex;
        align-items: center;
        margin-bottom: 9px;
        .m-des{
          font-size: 15px;
          color: #457DF9;
          font-weight: bold;
        }
      }
      .m-p{
        font-size: 14px;
        color: #FB2927;
      }
      .m-up-box{
        margin: 20px 10px 30px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap:30px;
        .m-file-box{
          width: 130px;
          img{
            width: 130px;
            height: 82px;
          }
        }
      }
      .m-prompt{
        width: 100%;
        padding: 10px 15px 12px 15px;
        background: #F9F9F9;
        border-radius: 4px;
        >p{
          text-align: center;
          color: #333333;
          font-size: 13px;
          margin-bottom: 11px;
        }
        .m-prompt-box{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .m-nav-prompt{
            display: flex;
            flex-direction: column;
            align-items: center;
            >img{
              width: 56px;
              height: 36px;
            }
            .m-icon{
              color: #4ADC47;
              font-size: 13px;
              margin-top: 6px;
              margin-bottom: 8px;
            }
            .m-icon-w{
              color: #F44442;
              font-size: 13px;
              margin-top: 6px;
              margin-bottom: 8px;
            }
            >span{
              font-size: 12px;
              color: #666666;
            }
          }
        }
      }
      .m-item{
        padding-bottom: 20px;
        display: flex;
        >span{
          display: inline-block;
          width: 90px;
          color: #8D8F93;
        }
        >p{
          flex: 1;
          text-align: right;
        }
      }
      .m-card-box{
        display: flex;
        padding: 0 34px;
        justify-content: space-between;
        .m-card-item{
          >img{
            width: 100px;
            height: 130px;
            margin-top: 3px;
          }
          .m-up-card{
            width: 109px;
            height: 137px;
          }
          >p{
            text-align: center;
            color: #666666;
            line-height: 18px;
          }
          .m-left-p{
            margin-top: 15px;
          }
          .m-right-p{
            margin-top: 12px;
          }
        }
      }
    }
    .des-bg{
      color: #666666;
      font-size: 14px;
      line-height: 18px;
      padding: 12px 5px 20px 5px;
    }
  }
</style>

